import React, { useState, useEffect } from "react";
import { data, useOutletContext, Link, useParams } from "react-router-dom";
import { postSetorSaham, getSahamSetor } from "../api/services/sahamApi";
import SubmitButton from "../components/buttons/SubmitButton";
import { currencyFormat } from "../components/utils/currencyFormat";
import { formatDate } from "../components/utils/fomatDate";
import InputNumber from "../components/forms/InputNumber";


function TambahSetorSaham() {
    
    /** Title Header Page */
    const {title, setTitle} = useOutletContext();
    setTitle('Setor Saham');
    
    /** useState */
    const [setor, setSetor] = useState('');
    const [dataSetor, setDataSetor] = useState({
        histori_setor : {data:[]},
        kurang_setor : 0 ,
    });
    const [isSubmiting, setIsSubmiting] = useState(false);

    const disabledPrevButton = dataSetor.histori_setor.current_page == 1 ? true : false;
    const disabledNextButton = dataSetor.histori_setor.current_page == dataSetor.histori_setor.last_page ? true : false;
    
    useEffect(() => {
        document.title = 'Setor Saham | Sembako';
        getSahamSetor(1).then(res => setDataSetor(res.data.data));
    },[])
    

    function handleNextClick(e) {
        if(!disabledNextButton) {
            const nextPage = dataSetor.histori_setor.current_page + 1;
            getSahamSetor(nextPage).then(res => setDataSetor(res.data.data));
        }
    }

    function handlePrevClick(e) {
        if(!disabledPrevButton) {
            const prevPage = dataSetor.histori_setor.current_page - 1;
            getSahamSetor(prevPage).then(res => setDataSetor(res.data.data));
        }
    }

    const handleSubmit = async(event) => {
        setIsSubmiting(true);
        event.preventDefault();
        try {
            const newPost = await postSetorSaham({
                setor
            });
            alert(`Setor sejumlah ${currencyFormat(setor)} behasil dibuat`);
            setSetor('');
            getSahamSetor(1).then(res => setDataSetor(res.data.data));
        } catch (error) {
            alert('Gagal menambahkan setor')
            console.log(error);
        };
        setIsSubmiting(false)
    }



    return(
        <>
            <div className="rounded-xl bg-gray-50 p-5 pt-10 pb-10 mt-10">
                <h3 class="text-x font-semibold">
                    Total yang belum <br/>disetor
                </h3>
                <span className="text-2xl mt-10 block">{ currencyFormat(dataSetor.kurang_setor) }

                {dataSetor.kurang_setor < 0 && (
                    <span className="text-sm itali text-green-700 ml-3"> Kelebihan</span>
                )}
                </span>
            </div>
            <form onSubmit={handleSubmit}>
                <InputNumber 
                    min={0}
                    label="Setor (jumlah uang)" 
                    value={setor == 0 ? '' : setor}
                    onChange={(e) => setSetor(e.target.value == '' ? 0 : e.target.value)}/>
                <div className="mt-10">
                    <SubmitButton disabled={setor != 0 && isSubmiting == false ? false : true}>
                        <svg className="inline-block mr-3 icon icon-tabler icons-tabler-outline icon-tabler-plus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                            ><path stroke="none" d="M0 0h24v24H0z" 
                            fill="none"/><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                            TAMBAH SETOR
                    </SubmitButton>
                </div>
            </form>
            <div className="mt-10">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold">Setor Terakhir</h3>
                </div>
                <div className="mt-7">
                    {
                        dataSetor.histori_setor.data.map((val, i) => 
                            <SetorCard 
                                setor={val.setor}
                                tanggal={val.created_at}
                            />
                        )
                    }
                    <div className="mt-10 flex justify-around centex items-center">
                        <button className="disabled:opacity-10 text-[#8570FF]" disabled={disabledPrevButton} onClick={(e) => handlePrevClick(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" 
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-left"><path stroke="none" 
                                d="M0 0h24v24H0z" fill="none"/><path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18" />
                                <path d="M8 12l4 4" /><path d="M8 12h8" /><path d="M12 8l-4 4" /></svg></button>
                        <span>{dataSetor.histori_setor.current_page} / {dataSetor.histori_setor.last_page}</span>
                        <button className="disabled:opacity-10 text-[#8570FF]" disabled={disabledNextButton} onClick={(e) => handleNextClick(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" 
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-right"><path stroke="none" 
                                d="M0 0h24v24H0z" fill="none"/><path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
                                <path d="M16 12l-4 -4" /><path d="M16 12h-8" /><path d="M12 16l4 -4" /></svg>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}


function SetorCard(props) {
    return (
        <>
            <div className="mt-7">
                <div className="mt-7 rounded-xl bg-gray-50 p-5">
                    <div className="flex justify-between items-center">
                        <h4 className="text-lg font-semibold">Jumlah Setor : {currencyFormat(props.setor)}</h4>
                        <span className="text-sm">{formatDate(props.tanggal)}</span>
                    </div>
                    {/* <div className="text-">Jumlah Setor : {currencyFormat(props.setor)}</div> */}
                </div>
            </div>
        </>
    )
}
export default TambahSetorSaham;